import Joi from "joi";
import { APPLE_PAY_PAYMENT_REQUEST_SCHEMA } from "./ApplePayPaymentRequestSchema";

export const APPLE_PAY_SCHEMA: Joi.ObjectSchema = Joi.object().keys({
  buttonStyle: Joi.string().valid("black", "white", "white-outline"),
  buttonText: Joi.string().valid(
    "plain",
    "buy",
    "book",
    "donate",
    "check-out",
    "subscribe",
  ),
  buttonPlacement: Joi.string(),
  merchantId: Joi.string(),
  merchantUrl: Joi.string(),
  paymentRequest: APPLE_PAY_PAYMENT_REQUEST_SCHEMA,
  placement: Joi.string()
    .warning("deprecate.error", { reason: "it is no longer supported" })
    .messages({
      "deprecate.error":
        "{#label} is deprecated because {#reason}. Please use buttonPlacement property.",
    }),
  callbacks: Joi.object().keys({
    onShippingMethodSelected: Joi.function(),
    onShippingContactSelected: Joi.function(),
    onPaymentAuthorized: Joi.function(),
    onCouponCodeChanged: Joi.function(),
  }),
});
